export const GET_ALL_POST_ACTIONS = {
    GET_ALL_POST_REQUEST: 'GET_ALL_POST_REQUEST',
    GET_ALL_POST_RESPONSE: 'GET_ALL_POST_RESPONSE',
    GET_ALL_POST_ERROR: 'GET_ALL_POST_ERROR'
};
export const GET_TRENDING_POST_ACTIONS = {
    GET_TRENDING_POST_REQUEST: 'GET_TRENDING_POST_REQUEST',
    GET_TRENDING_POST_RESPONSE: 'GET_TRENDING_POST_RESPONSE',
    GET_TRENDING_POST_ERROR: 'GET_TRENDING_POST_ERROR'
};
export const GET_POST_DETAILS_BY_ID_ACTIONS = {
    GET_POST_DETAILS_BY_ID_REQUEST: 'GET_POST_DETAILS_BY_ID_REQUEST',
    GET_POST_DETAILS_BY_ID_RESPONSE: 'GET_POST_DETAILS_BY_ID_RESPONSE',
    GET_POST_DETAILS_BY_ID_ERROR: 'GET_POST_DETAILS_BY_ID_ERROR'
};
export const GET_RECENT_POSTS_BY_USERID_ACTIONS = {
    GET_RECENT_POSTS_BY_USERID_REQUEST: 'GET_RECENT_POSTS_BY_USERID_REQUEST',
    GET_RECENT_POSTS_BY_USERID_RESPONSE: 'GET_RECENT_POSTS_BY_USERID_RESPONSE',
    GET_RECENT_POSTS_BY_USERID_ERROR: 'GET_RECENT_POSTS_BY_USERID_ERROR'
};
export const GET_JOINED_POSTS_BY_USERID_ACTIONS = {
    GET_JOINED_POSTS_BY_USERID_REQUEST: 'GET_JOINED_POSTS_BY_USERID_REQUEST',
    GET_JOINED_POSTS_BY_USERID_RESPONSE: 'GET_JOINED_POSTS_BY_USERID_RESPONSE',
    GET_JOINED_POSTS_BY_USERID_ERROR: 'GET_JOINED_POSTS_BY_USERID_ERROR'
};
export const CREATE_POST_NEW_ACTIONS = {
    CREATE_POST_NEW_REQUEST: 'CREATE_POST_NEW_REQUEST',
    CREATE_POST_NEW_RESPONSE: 'CREATE_POST_NEW_RESPONSE',
    CREATE_POST_NEW_ERROR: 'CREATE_POST_NEW_ERROR'
};
export const DELETE_POST_ID_ACTIONS = {
    DELETE_POST_REQUEST: 'DELETE_POST_REQUEST',
    DELETE_POST_RESPONSE: 'DELETE_POST_RESPONSE',
    DELETE_POST_ERROR: 'DELETE_POST_ERROR'
};
export const UPDATE_POST_NEW_ACTIONS = {
    UPDATE_POST_NEW_REQUEST: 'UPDATE_POST_NEW_REQUEST',
    UPDATE_POST_NEW_RESPONSE: 'UPDATE_POST_NEW_RESPONSE',
    UPDATE_POST_NEW_ERROR: 'UPDATE_POST_NEW_ERROR'
};
export const PUT_JOIN_POST_ACTIONS = {
    PUT_JOIN_POST_REQUEST: 'PUT_JOIN_POST_REQUEST',
    PUT_JOIN_POST_RESPONSE: 'PUT_JOIN_POST_RESPONSE',
    PUT_JOIN_POST_ERROR: 'PUT_JOIN_POST_ERROR'
}
export const LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS = {
    LIKE_UNLIKE_POST_AND_COMMENTS_RESPONSE: ' LIKE_UNLIKE_POST_AND_COMMENTS_RESPONSE',
    LIKE_UNLIKE_POST_AND_COMMENTS_REQUEST: ' LIKE_UNLIKE_POST_AND_COMMENTS_REQUEST',
    LIKE_UNLIKE_POST_AND_COMMENTS_ERROR: ' LIKE_UNLIKE_POST_AND_COMMENTS_ERROR',
};
export const REPLAY_POST_NEW_ACTIONS = {
    REPLAY_POST_NEW_RESPONSE: ' REPLAY_POST_NEW_RESPONSE',
    REPLAY_POST_NEW_REQUEST: ' REPLAY_POST_NEW_REQUEST',
    REPLAY_POST_NEW_ERROR: ' REPLAY_POST_NEW_ERROR',
};
export const COMMENTS_REPLY_ACTIONS = {
    COMMENTS_REPLY_ACTIONS_RESPONSE: ' COMMENTS_REPLY_ACTIONS_RESPONSE',
    COMMENTS_REPLY_ACTIONS_REQUEST: ' COMMENTS_REPLY_ACTIONS_REQUEST',
    COMMENTS_REPLY_ACTIONS_ERROR: ' COMMENTS_REPLY_ACTIONS_ERROR',
};

export const UPDATE_REPLAY_POST_NEW_ACTIONS = {
    UPDATE_REPLAY_POST_NEW_RESPONSE: ' UPDATE_REPLAY_POST_NEW_RESPONSE',
    UPDATE_REPLAY_POST_NEW_REQUEST: ' UPDATE_REPLAY_POST_NEW_REQUEST',
    UPDATE_REPLAY_POST_NEW_ERROR: ' UPDATE_REPLAY_POST_NEW_ERROR',
};
export const UPDATE_COMMENTS_REPLY_ACTIONS = {
    UPDATE_COMMENTS_REPLY_RESPONSE: ' UPDATE_COMMENTS_REPLY_RESPONSE',
    UPDATE_COMMENTS_REPLY_REQUEST: ' UPDATE_COMMENTS_REPLY_REQUEST',
    UPDATE_COMMENTS_REPLY_ERROR: ' UPDATE_COMMENTS_REPLY_ERROR',
};

export const POST_REPORT_ACTIONS = {
    POST_REPORT_RESPONSE: ' POST_REPORT_RESPONSE',
    POST_REPORT_REQUEST: ' POST_REPORT_REQUEST',
    POST_REPORT_ERROR: ' POST_REPORT_ERROR',
};

export const DELETE_COMMENTS_NEW_ACTIONS = {
    DELETE_COMMENTS_NEW_RESPONSE: 'DELETE_COMMENTS_NEW_RESPONSE',
    DELETE_COMMENTS_NEW_REQUEST: 'DELETE_COMMENTS_NEW_REQUEST',
    DELETE_COMMENTS_NEW_ERROR: 'DELETE_COMMENTS_NEW_ERROR',
};
export const DELETE_COMMENTS_REPLY_ACTIONS = {
    DELETE_COMMENTS_REPLY_RESPONSE: 'DELETE_COMMENTS_REPLY_RESPONSE',
    DELETE_COMMENTS_REPLY_REQUEST: 'DELETE_COMMENTS_REPLY_REQUEST',
    DELETE_COMMENTS_REPLY_ERROR: 'DELETE_COMMENTS_REPLY_ERROR',
};